export default "__VITE_ASSET__C3j9fnMo__"